import React from "react";
import { Link } from "react-router-dom";

const Text = () => (
  <section className="text">
    <div className="container">
      <p className="text__title">
        Interested in collaborating or working together?
      </p>
      <p className="text__subtitle">
        If you like to create things as much as I do.
      </p>
      <Link to="/contact" className="text__btn">
        Start a conversation
      </Link>
    </div>
  </section>
);

export default Text;
